// Matches the photo hold time (slideDuration default) so all slides share one cadence.
export const MIN_VIDEO_DWELL_MS = 5000;

export const getVideoPlayback = (videoDurationMs, { isSolo = false, minDwellMs = MIN_VIDEO_DWELL_MS } = {}) => {
  if (isSolo) {
    return { loop: true, advanceAfterMs: null };
  }
  const durationMs = Math.round(videoDurationMs) || 0;
  if (durationMs < minDwellMs) {
    return { loop: true, advanceAfterMs: minDwellMs };
  }
  return { loop: false, advanceAfterMs: null };
};
